import { createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

const slice = createSlice({
  name: 'providerManagement',
  initialState: {
    pagesListLoading: false,
    pagesList: [],
    paginationData: {},
    updatePages: false,
  },
  reducers: {
    //pages
    getPagesData: (state, { payload }) => {
      state.pagesListLoading = true
    },
    getPagesDataSuccess: (state, { payload }) => {
      state.pagesListLoading = false
      state.pagesList = payload?.payload?.data

      state.paginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getPagesDataFailure: (state, { payload }) => {
      state.pagesListLoading = false
    },

    //edit pages
    editPagesData: (state) => {
      state.updatePages = false
    },
    editPagesDataSuccess: (state) => {
      state.updatePages = true
    },
    editPagesDataFailed: (state) => {
      state.updatePages = false
    },

    //delete pages
    deletePagesData: (state, { payload }) => {
      let updatePagesList = state.pagesList?.filter((item) => item.id !== payload?.id)
      state.updatePages = false
      state.pagesList = updatePagesList
    },
    deletePagesDataSuccess: (state) => {
      state.updatePages = true
    },
    deletePagesDataFailed: (state) => {
      state.updatePages = false
    },

    //add pages
    addPagesData: (state, { payload }) => {
      const last = state.pagesList[state.pagesList.length - 1]?.id || 0
      state.pagesList = [
        ...state.pagesList,
        { id: last + 1, ...payload, created_at: moment().format() },
      ]
      state.updatePages = false
    },
    addPagesDataSuccess: (state) => {
      state.updatePages = true
    },
    addPagesDataFailed: (state) => {
      state.updatePages = false
    },
  },
})

export const {
  //get pages
  getPagesData,
  getPagesDataSuccess,
  getPagesDataFailure,

  //edit pages
  editPagesData,
  editPagesDataSuccess,
  editPagesDataFailed,

  //delete pages
  deletePagesData,
  deletePagesDataSuccess,
  deletePagesDataFailed,

  //add pages
  addPagesData,
  addPagesDataSuccess,
  addPagesDataFailed,
} = slice.actions

export default slice.reducer
